import {isChild, isPartner} from '../../properties/relationships';
import {
    CHILD_VOLUNTARY_TERM_LIFE_SORT_CODE,
    EMPLOYEE_VOLUNTARY_TERM_LIFE_ADND_SORT_CODE,
    EMPLOYEE_VOLUNTARY_TERM_LIFE_SORT_CODE,
    MULTIPLE_OF_PAY_PLAN_TYPE,
    SPOUSE_VOLUNTARY_TERM_LIFE_ADND_SORT_CODE,
    SPOUSE_VOLUNTARY_TERM_LIFE_SORT_CODE
} from '../../properties/coverages';
import {getCoverageBySortCode} from '../../utils/rates/getCoverageBySortCodeUtil';
import {buildIncrementRates} from '../../utils/rates/buildIncrementRatesUtil';
import {getGuaranteedIssueAmount} from '../../utils/rates/getGuaranteedIssueAmountUtil';
import {buildChildRates} from '../../utils/rates/buildChildRatesUtil';
import {getCoverage} from '../../utils/rates/getCoverageUtil';
import {getDependentCannotExceedPercent} from '../../utils/rates/getDependentCannotExceedPercentUtil';
import {buildMultipleOfPayRates} from '../../utils/rates/buildMultipleOfPayRatesUtil';

export const voluntaryTermLifeRateSelector = (state) => {
    const firstAvailableMemberGroupKey = state.memberElection.memberGroups[0];

    const convertToRateTranche = (rate, memberGroupKey) => {
        const employeeCoverage = getCoverageBySortCode(state, memberGroupKey, EMPLOYEE_VOLUNTARY_TERM_LIFE_SORT_CODE);
        const employeeADnDCoverage = getCoverageBySortCode(state, memberGroupKey, EMPLOYEE_VOLUNTARY_TERM_LIFE_ADND_SORT_CODE);
        const spouseCoverage = getCoverageBySortCode(state, memberGroupKey, SPOUSE_VOLUNTARY_TERM_LIFE_SORT_CODE);
        const spouseADnDCoverage = getCoverageBySortCode(state, memberGroupKey, SPOUSE_VOLUNTARY_TERM_LIFE_ADND_SORT_CODE);
        const childCoverage = getCoverageBySortCode(state, memberGroupKey, CHILD_VOLUNTARY_TERM_LIFE_SORT_CODE);

        const spouse = state.memberElection.familyDemographics.dependents.find(dependent => isPartner(dependent.relationship));
        return {
            memberGroupKey: rate.memberGroupKey,
            esclKey: rate.esclKey,
            employeeRates: employeeCoverage.planType === MULTIPLE_OF_PAY_PLAN_TYPE
                ? buildMultipleOfPayRates(
                    state,
                    rate,
                    employeeCoverage,
                    employeeCoverage.benefitKey,
                    EMPLOYEE_VOLUNTARY_TERM_LIFE_SORT_CODE)
                : buildIncrementRates(
                    state,
                    rate,
                    employeeCoverage.benefitOptions,
                    state.memberElection.memberDemographics.dateOfBirth,
                    state.memberElection.memberDemographics.smoker,
                    state.memberElection.memberDemographics.gender,
                    employeeCoverage.benefitKey,
                    EMPLOYEE_VOLUNTARY_TERM_LIFE_SORT_CODE
                ),
            employeeGuaranteedIssueAmount: getGuaranteedIssueAmount(employeeCoverage.benefitOptions, state.memberElection.memberDemographics.dateOfBirth),
            spouseBenefitKey: spouseCoverage && spouseCoverage.benefitKey,
            spouseADnDBenefitKey: spouseADnDCoverage && spouseADnDCoverage.benefitKey,
            spouseRates: spouseCoverage && spouse
                ? buildIncrementRates(
                    state,
                    rate,
                    spouseCoverage.benefitOptions,
                    spouse.dateOfBirth,
                    spouse.smoker,
                    spouse.gender,
                    spouseCoverage.benefitKey,
                    SPOUSE_VOLUNTARY_TERM_LIFE_SORT_CODE
                )
                : [],
            spouseGuaranteedIssueAmount: spouseCoverage && getGuaranteedIssueAmount(spouseCoverage.benefitOptions, spouse && spouse.dateOfBirth),
            spouseCannotExceedPercent: spouseCoverage && getDependentCannotExceedPercent(spouseCoverage.benefitOptions),
            childCannotExceedPercent: childCoverage && getDependentCannotExceedPercent(childCoverage.benefitOptions),
            childBenefitKey: childCoverage && childCoverage.benefitKey,
            childRates: childCoverage
            && state.memberElection.familyDemographics.dependents.some(dependent => isChild(dependent.relationship))
                ? buildChildRates(state, rate, childCoverage.benefitKey, childCoverage.benefitOptions, CHILD_VOLUNTARY_TERM_LIFE_SORT_CODE, childCoverage.allowedAmounts)
                : [],
            employeeADnDBenefitKey: employeeADnDCoverage && employeeADnDCoverage.benefitKey,
            employeeADnDEsclKey: rate.esclKey,
            spouseADnDEsclKey: rate.esclKey,
            ...getCoverage(state, rate.memberGroupKey, rate.bntpKey)
        };
    };

    if (!Boolean(state.memberElection.memberDemographics.dateOfBirth)) {
        return undefined;
    }
    return state.policyData.rates
        .filter(rate => rate.rateProduct.compassGroupSortCode === EMPLOYEE_VOLUNTARY_TERM_LIFE_SORT_CODE
            && rate.memberGroupKey === firstAvailableMemberGroupKey)
        .map(rate => convertToRateTranche(rate, firstAvailableMemberGroupKey))[0];
};